import { append, is, filter } from 'ramda';
import { Constraint } from '../types/FormJson';

export const appendIfNot = (newConstraint: Constraint, constraints: Constraint[]) => {
  const index = constraints.findIndex(item => item.fieldId === newConstraint.fieldId && item.id === newConstraint.id);

  if (index !== -1) {
    return constraints;
  }

  return append(newConstraint, constraints);
};

export const removeIfExists = (constraint: Constraint | string, constraints: Constraint[]) => {
  return filter(row => {
    if (is(Object, constraint)) {
      // @ts-ignore
      return row.fieldId === constraint.fieldId ? row.id !== constraint.id : true;
    }

    return row.id !== constraint;
  }, constraints);
};
